





















































  import Vue from 'vue';
import Component from 'vue-class-component';
  
  @Component
  export default class PlaygroundPagination extends Vue {
    public totalItemsCount:number = 500;
    public itemsPerPage:number = 25;
    public activePage:number = 1;
    
    mounted(){
      this.$refs.paginationPlayground.addEventListener('pageChange', (e) => {
        this.activePage = e.detail.page;
      });
    }
  }
